import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type InformationModesFetchedPayload = LabeledValuePayload[];

export type InformationModesFetchedAction = {
	type: 'INFORMATION_MODES_FETCHED';
	payload: InformationModesFetchedPayload;
};

export default (payload: InformationModesFetchedPayload): InformationModesFetchedAction => ({
	type: 'INFORMATION_MODES_FETCHED',
	payload,
});
